import React from "react";
import styled from "styled-components";

type Status = "ok" | "dropping" | "silent";

interface Props {
  status: Status;
}

const LABELS: Record<Status, string> = {
  ok: "OK",
  dropping: "Dropping",
  silent: "Silent",
};

const COLORS: Record<Status, { bg: string; text: string }> = {
  ok: { bg: "#e8f5e9", text: "#2e7d32" },
  dropping: { bg: "#fff3e0", text: "#e65100" },
  silent: { bg: "#ffebee", text: "#c62828" },
};

const SourceStatusBadge: React.FC<Props> = ({ status }) => (
  <Badge $bg={COLORS[status].bg} $color={COLORS[status].text}>
    {LABELS[status]}
  </Badge>
);

export default SourceStatusBadge;

const Badge = styled.span<{ $bg: string; $color: string }>`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  white-space: nowrap;
`;
